import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Link from 'shared/components/Link';
import InlineNav from '../InlineNav/InlineNav';
import Balance from '../Balance/Balance';
import s from './SubHeader.css';

class SubHeader extends React.Component {
  static propTypes = {
    navLinks: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        route: PropTypes.string,
      }),
    ).isRequired,
    currentRoute: PropTypes.string,
    personalSubheader: PropTypes.bool.isRequired,
    user: PropTypes.shape({
      tariff: PropTypes.shape({
        title: PropTypes.string,
        is_business: PropTypes.bool,
      }),
    }).isRequired,
    including: PropTypes.bool.isRequired,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    currentRoute: '',
  };

  isActive = tariff => {
    const expireDate = tariff && tariff.expire_date && new Date(tariff.expire_date);
    const today = new Date();

    return expireDate > today;
  };

  render() {
    const { navLinks, currentRoute, personalSubheader, user, including, intl } = this.props;
    const sparePartsTariff = user && user.spareparts_tariff;

    return (
      <div className={s.root} role="navigation">
        <div className={s.container}>
          <div className={s.left}>
            <InlineNav
              navLinks={navLinks}
              currentRoute={currentRoute}
              including={including}
              eventPrefix={'subHeader'}
            />
          </div>
          <div className={s.right}>
            {personalSubheader &&
              <div>
                {sparePartsTariff &&
                  sparePartsTariff.slug &&
                  <Link
                    to="/profile/"
                    className={cx(s.tariff, {
                      [s.nonActiveTariff]: !this.isActive(sparePartsTariff),
                    })}
                    title={
                      this.isActive(sparePartsTariff)
                        ? undefined
                        : intl.formatMessage({ id: 'Действие пакета закончилось' })
                    }
                  >
                    <FormattedMessage id={sparePartsTariff.title} />
                  </Link>}

                {user.tariff &&
                  user.tariff.is_business &&
                  <Link
                    to="/profile/"
                    className={cx(s.tariff, {
                      [s.nonActiveTariff]: !this.isActive(user.tariff),
                    })}
                    title={
                      this.isActive(user.tariff)
                        ? undefined
                        : intl.formatMessage({ id: 'Действие пакета закончилось' })
                    }
                  >
                    <FormattedMessage id={user.tariff.title} />
                  </Link>}

                <div className={s.balance}>
                  <Balance />
                </div>
              </div>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user: user.user,
});

export default withStyles(s)(connect(mapStateToProps, {})(injectIntl(SubHeader)));



// WEBPACK FOOTER //
// ./src/desktop/components/SubHeader/SubHeader.js